var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Video Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.8,48H10.28a3.92,3.92,0,0,1-3.9-3.9V14.73a3.92,3.92,0,0,1,3.9-3.9H44.93a3.92,3.92,0,0,1,3.91,3.9V32.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.7,
    y1: 47.98,
    x2: 28.7,
    y2: 47.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.48,
    y1: 22.7,
    x2: 9.48,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.71,
    cy: 29.4,
    r: 9.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.18 33.38 25.18 25.42 32.25 28.96 25.18 33.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.47,
    y1: 40.46,
    x2: 9.47,
    y2: 25.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.6,38.35a.77.77,0,0,0-.53-.52.76.76,0,0,0-.72.19l-3.9,3.82-2.86-.57L47,38.42,51,34.56a.75.75,0,0,0,.21-.71.76.76,0,0,0-.5-.54,7.7,7.7,0,0,0-2.23-.37A7.48,7.48,0,0,0,41,40.41a7.34,7.34,0,0,0,.17,1.5c-.83.7-1.63,1.29-2.53,2-1.3,1-2.76,2-4.75,3.74a5.22,5.22,0,0,0,3.38,9.21,5.19,5.19,0,0,0,4-1.87c1.72-2,2.82-3.49,3.8-4.79.66-.88,1.24-1.66,1.91-2.48a6.89,6.89,0,0,0,1.51.18,7.37,7.37,0,0,0,7.15-9.52ZM37.26,53.1a1.5,1.5,0,1,1,1.49-1.5A1.5,1.5,0,0,1,37.26,53.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSettings01);
export default __webpack_public_path__ + "static/media/Video_Settings_01.9669e693dae283a0bc9e184dfce4fdf1.svg";
export { ForwardRef as ReactComponent };